import CreateShareableLinkButton from './CreateShareableLinkButton.component';

export default CreateShareableLinkButton;